
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-basic-graph-demo-auto-resize","docs-tutorial-basic-graph-demo-background-grid","docs-tutorial-basic-graph-demo-panning-mousewheel","docs-tutorial-basic-graph-demo-transform"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.en.md?type=demo')
};